export default "__VITE_ASSET__75ebf61b__"